import { useState } from "react";
import { useUser } from "../../context/user-context";
import apiRoutes from "../../api/routes";
import useApiRequest from "../../api/api";
import WalletConnectComponent from "./wallet/connect-wallet";
import { useNavigate } from "react-router-dom";
import routes from "../../constants/routes";

const WalletConnector = ({ children, shouldNavigate = false }) => {
  const [openWalletModal, setIsOpenWalletModal] = useState(false);
  const { makeApiCall } = useApiRequest();
  const { user, updateUser } = useUser();
  const navigate = useNavigate();
  const handleWalletConnected = async (address, name) => {
    try {
      const payload = { address, WalletName: name };
      const response = await makeApiCall(
        apiRoutes.wallet.connect_wallet,
        "POST",
        payload,
        "show"
      );
      if (response.success) {
        const updatedUser = {
          ...user,
          wallet: response.data,
        };

        localStorage.setItem("user", JSON.stringify(updatedUser));
        updateUser(updatedUser);
        setIsOpenWalletModal(false); // Close modal
        if (shouldNavigate) {
          navigate(routes.home);
        }
      }
    } catch (error) {
      console.error("Wallet connection failed:", error);
    }
  };

  return (
    <>
      {/* Button is passed as a child */}
      {children({ handleOpenModal: () => setIsOpenWalletModal(true) })}

      {openWalletModal && (
        <WalletConnectComponent
          onWalletConnected={handleWalletConnected}
          isOpen={openWalletModal}
          onClose={() => setIsOpenWalletModal(false)}
        />
      )}
    </>
  );
};

export default WalletConnector;
